export default Object.freeze({
  PRIMARY: 1,
  SECONDARY: 2,
  OTHER: 3,
});
